import { useSelector } from 'react-redux';

export function useSelfHostedKnowledgeBase() {
  const featureFlags = useSelector((state) => {
    return state.app.featureFlags;
  });

  return !!featureFlags.includes('OFFLINE_ENVIRONMENT') && '/knowledge_base';
}

export const PRATUS_KNOWLEDGE_URL = 'https://pratus.disastertech.com/knowledge';

export const HelpActivity = {
  title: 'Activity Home',
  content: `
        <p>View MSEL inject activity in chronological order from members of your workspace. Click the name of the MSEL inject to view more details.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

//miscellaneous use

export const MiscellaneousHelpLink = {
  link: PRATUS_KNOWLEDGE_URL,
};

// Settings Module

export const HelpUserSettings = {
  title: 'User Settings',
  content: `
        <p>Change your Name by filling in where it says Name and then click Save. </p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};
export const HelpMembers = {
  title: 'User Roles',
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpWorkspaceMembers = {
  title: 'Workspace Members',
  content: `
        <p>Anyone can invite a new or current user to the workspace by typing in their email address. Admins may select a role for the new user by clicking the Select Role for User drop-down.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTimeZone = {
  title: 'Time Zone',
  content: `
        <p>Set a unified time zone for your workspace by selecting the Set Time Zone button. When a time zone is set,
        all users within a workspace view a unified time zone. If a time zone is not chosen, or is reset to local time, each user will see the time zone set from their device, which may be different across users.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanJmets = {
  title: 'Plan JMETs',
  content: `
        <p>JMETS are included in the app and are used in the Training Objectives and Accredited Tasks section of Plan. Create a JMET in the workspace by clicking the button at the top of the screen. Then fill in the details and select Save. Edit or Delete a JMET by select the more options icon on the right-hand side of the JMET. Select the Level of War, Task Number, or Task Title to change the viewing order of the JMETs.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanOrganizations = {
  title: 'Plan Organizations',
  content: `
        <p>Organizations represent the sponsors/owners of an exercise. Users can create, edit, or delete an Organization in Settings. Organizations are selected in the Exercise Details section of EMW. Create an Organization by clicking the button "Add Organization". There are two levels you can fill, "Name" and "Group" in the case that there are multiple sub-organizations. Click Save. Edit or Delete an Organization by selecting the three-dot icon on the right-hand side of the desired entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanPlatforms = {
  title: 'Plan Platforms',
  content: `
        <p>Platforms are included in the app and are used when choosing a Participant Platform in Plan. Users can create, edit, or delete them on the Settings page. Fill in the Title and Type, then click Save. Edit or Delete Platforms by selecting the more options icon on the right-hand side of the Platform.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantTypes = {
  title: 'Participant Types',
  content: `
        <p>The Essential Support Function or type of organization of the participant. The selectable values are customizable to meet the exercise needs, and used as a filter for the Feedback and Reports sections of the application. Add, edit, or delete an ESF/Organization Type by selecting the Add ESF/Organization Type button; click on the three dots under the Action column to edit or delete an entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpServiceDepartment = {
  title: 'Service/Department',
  content: `
        <p>Describes a structured level of the participating organization. Add, edit, or delete as required to meet the specific criteria of your exercise. Add an entry by selecting the Add City/Town/Service/Department button; click on the three dots under the Action column to edit or delete an entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpServiceDepartmentTypes = {
  title: 'Service/Department Types',
  content: `
        <p>Describes a type of level of the participating organization. Add, edit, or delete as required to meet the specific criteria of your exercise. Add an entry by selecting the Add Jurisdiction/Service/Department button; click on the three dots under the Action column to edit or delete an entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpCommandAgency = {
  title: 'Command/Agency',
  content: `
        <p>Describes a structured level of your organization and is customizable to meet the specific criteria of your exercise. Add by selecting the State/County/Chapter/Command/Agency button; click on the three dots under the Action column to edit or delete an entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanJointStaffTrainingPriorities = {
  title: 'Strategic Priorities',
  content: `
        <p>Users can define desired Strategic Priorities to align participant objectives. Create a Strategic Priority by selecting the button "Add Strategic Priority". Add the Title and Description, then click Save. Edit or Delete a Strategic Priority by selecting the three-dot icon on the right-hand side of each.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpInjectMethod = {
  title: 'Inject Method',
  content: `
        <p>Inject Methods are used when creating a MSEL Inject. Inject Methods are preset but can be modified to include additional methods by selecting Create Method. Easily identify the Inject Method by adding a unique name, icon, and color. Delete or Edit an Inject Method by selecting the more option icon.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpInjectOwner = {
  title: 'Inject Owner',
  content: `
        <p>Inject Owners are used in the first step when creating a MSEL Inject. Inject Owners are preset but can be modified to include additional owners by selecting Create Owner. Delete or Edit an Inject Owner by selecting the more options icon.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpExcerciseType = {
  title: 'Excercise Type',
  content: `
        <p>Defines the type of exercise being conducted. Add a new entry by selecting on “Add Exercise Type”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpFromTo = {
  title: 'From To',
  content: `
        <p>Defines the notional entity the MSEL Inject is being sent from and the entity the inject trigger is being sent to. Add a new entry by selecting “Add From To”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTechnicalDiscipline = {
  title: 'Technical Discipline',
  content: `
        <p>Click the "more help" button for further information.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMissionTypes = {
  title: 'Mission Type',
  content: `
        <p>Click the "more help" button for further information.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMissionProfile = {
  title: 'Mission Profile',
  content: `
        <p>Click the "more help" button for further information.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};
export const HelpMissionLocation = {
  title: 'Mission Location',
  content: `
        <p>Click the "more help" button for further information.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPosition = {
  title: 'Position',
  content: `
        <p>Defines the role a member is fulfilling within each participating organization. Select “Add Position”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};
export const HelpMetric = {
  title: 'Metric',
  content: `
        <p>Add supporting data to help provide depth to the accomplishment of a participant objective, Select “Add Metric”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPrimarySource = {
  title: 'Primary Source',
  content: `
        <p>Define the primary source of funding for the exercise budget. Select “Add Primary Source”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};
export const HelpSubSource = {
  title: 'Sub Source',
  content: `
        <p>Define a sub-source of funding for the exercise budget (as necessary). Select “Add Sub Source”, input a name, and click “Save Changes”. Click on the three dots under Action to edit the name or delete the entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpSupprt = {
  title: 'Support',
  content: '<p>Click the "more help" button for further information.</p>',
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanStatusLabels = {
  title: 'Plan Status Labels',
  content: `
        <p>Define the statuses of MSEL injects with Status Labels . Edit the title or color by click on the three dots under the Action column of each label.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanStatusBoards = {
  title: 'Plan Status Boards',
  content: `
        <p>Define the statuses of MSEL injects with Status Labels . Edit the title and/or select the desired labels for each board by clicking on the three dots under the Action column to edit or delete an entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanAssessmentReasons = {
  title: 'Assessment Reasons',
  content: `
        <p>Reasons explain the ineffectiveness of completing objectives in Assessment and Feedback forms. Create a new entry by selecting the “Add Assessment Reason” button. Input the Title and click Save Changes.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingPriority = {
  title: 'Objective Priority',
  content: `
        <p>Objective Priorities are used when creating or editing an objective. Priorities can be added by selecting Create Objective Priority. Click on the three dot menu under “Action” to edit the name or color, or to delete it.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

// Plan Module

export const HelpPreparePlan = {
  title: 'EMW Plan',
  content: `
        <p>This dashboard presents the Exercise Details, MSEL List, and Calendar showing the dates and times of the scenario-based Events . These displays allow users to have quick visualization and access to critical sections for planning an exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPrepareDashboard = {
  title: 'EMW Dashboard',
  content: `
        <p>The EMW dashboard presents the Exercise Details, MSEL Inject graph, and Calendar showing the dates and times of MSEL Injects. These displays allow users to quickly view critical and access sections for planning an exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpExerciseMain = {
  title: 'Exercise Details',
  content: `
        <p>Create the training environment for your training exercise by determining the focus of the 
        exercise and training objectives. In this section, add the exercise details, plan meetings,
        funding sources, objectives, and tasks and priorities. Select Edit Guidance to begin creating exercise details.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpExerciseDetails = {
  title: 'Exercise Details',
  content: `
        <p>Under Commander's Guidance, state the strategic objective.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanningMeetings = {
  title: 'Planning Meetings',
  content: `
        <p>Schedule your Planning Meetings to support the development of your exercise.</p>
        <p>If following the Joint Exercise Life Cycle, you may enter those events here or name your own planning meetings.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpFundingSources = {
  title: 'Funding Sources',
  content: `
        <p>Select Funding Sources, Sub-sources, and Amounts here. The Primary Source is the main source of funding received for the exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpExerciseObjectives = {
  title: 'Exercise Objectives',
  content: `
        <p>Create SMART Exercise Objectives that are specific, measurable, achievable, relevant and time-bound. Only the Title has to be filled out to move to the next step. Planners may return to the previous step and edit as needed.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTasksPriorities = {
  title: 'Tasks & Priorities',
  content: `
        <p>Select Add Acredited Task. Choose Accredited Task and hit Save or Cancel.</p>
        <p>Choose the Add Command Priority button. Fill in the Title and Description. Once completed, select Save or Cancel.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpExerciseDetailsReview = {
  title: 'Review',
  content: `
        <p>Review your exercise details and complete any remaining sections.</p>
        <p>Sections in red have an error and need review.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipants = {
  title: 'Participants',
  content: `
        <p>Add participants to your training scenario and exercises. These details are used for future objectives and to create a participant training group. The Participants section contains the list of participants, participant platforms, participant planners, contacts, training objectives, and funding sources. Select Create Participant, add the name and press Save. Then, follow the numbered stepper.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantDetails = {
  title: 'Participant Details',
  content: `
        <p>Input details regarding the participant. For each participant, enter the Name, Service or Department, Command or Agency, Participant Type, Home Station, Select an Icon, and Total Training Audience.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantPlatforms = {
  title: 'Participant Platforms',
  content: `
        <p>Add all platforms for the participant. Platforms can be modified in the Plan section of Settings. Select the platform from the fixed drop-down and add the Operating Location. Then click Save to continue or Cancel to return to the previous page.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantPlanners = {
  title: 'Participant Planners',
  content: `
        <p>Select the email of the user that is planning for this participant. Selecting the email adds the user to the participant platform. To designate a primary point of contact, select the Primary Contact checkbox for that user. Only users who are added to this exercise can be selected. If a user does not appear on the list, ensure they have an account and have been given access to the exercise workspace.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantFundingSources = {
  title: 'Funding Sources',
  content: `
        <p>Add the sources and funding amount for the participant. This should align with the funding sources for this exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantReview = {
  title: 'Review',
  content: `
        <p>Review the participant details for accuracy. Return to any section to edit by selecting the numbered step that correlates with the area you need to modify.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpParticipantDetailsandTrainingObjectives = {
  title: 'Participant Details and Training Objectives',
  content: `
        <p>This page shows details regarding the participant and their associated training objectives. On the Details tab, select the more options icon to edit or delete the participant. Click the Training Objectives tab to view and create training objectives for the selected participant.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingObjectives = {
  title: 'Training Objectives',
  content: `
        <p>Create Training Objectives for participants in the training exercise. Begin adding Training Objectives by selecting Create Training Objective. Once completed,
        Training Objectives appear in this list. Select the arrow associated with the Training Objective to view additional details.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingObjectiveDetails = {
  title: 'Training Objective Details',
  content: `
        <p>Select the participant platform for the Training Objective and fill in the details as desired. Most details are predetermined by the participant previously chosen.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingObjectiveMeasures = {
  title: 'Training Objective Measures',
  content: `
        <p>Describe the task, conditions, and standards for the training objective. These details are used when evaluating and providing feedback. To see examples, click the More Help button.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingObjectiveAssociations = {
  title: 'Training Objective Associations',
  content: `
        <p>Add further data that the Training Objective supports. View Exercise Objective details at anytime by clicking on View Exercise Details. The dropdowns of the Training Objective Associations have predetermined options. Add all necessary details on the Training Objective Measures page.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainingObjectiveReview = {
  title: 'Training Objective Review',
  content: `
        <p>Review the Training Objective information. To return or edit any section, click the edit button next to that section, or the numbered step along the top of the page.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpEvents = {
  title: 'Events',
  content: `
        <p>Events, which have a unique Master Scenario Events List (MSEL) of injects, allow users to develop scenarios within exercises. MSELs drive the event forward to support the training objectives that are associated with participants. Begin creating an event by selecting Create Event and completing the missing information.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanEvent = {
  title: 'Plan Event',
  content: `
        <p>Events allow users to develop scenarios within exercises. Events have a unique Master Scenario Events List of injects that drive the event forward to support the participant’s training objectives.</p>
        <p>Give the event a unique name and color to easily distinguish specific events, select the Overall Method from the drop-down, add the Start Date and End Date, and type in additional details in the Scenario and Remarks boxes.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpEventDetails = {
  title: 'Event Details',
  content: `
        <p>Manage the event and associated MSEL Injects. Select Add MSEL Inject or Edit Event to add important details to the event.
         Access the tools to Edit Inject, Remove From Event, or Delete Inject by clicking the more options icon, which is located on the right-hand side of the MSEL Inject.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanInjects = {
  title: 'Plan Injects',
  content: `
        <p>Monitor the status of MSEL Injects. Status Labels, chosen in the Status Boards section of Settings, simplify the process of tracking MSEL Statuses. Select Create MSEL Inject to add a new MSEL Inject or click the drop-down to Manage Boards. Filter MSEL Injects from the Events drop-down.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanInjectDetail = {
  title: 'Plan Inject Detail',
  content: `
        <p>To create a MSEL Inject, the user must enter a title; however, all other information can be completed as needed. The Plan Label designates the planning status of each inject.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpPlanInjectDescriptionMeasures = {
  title: 'Plan Inject Description & Measures',
  content: `
        <p>The MSEL Inject's Description is the trigger, which is information that drives an Anticipated Response from the training audience. The trigger can be sent via email, phone call, white card, media, etc. To support the inject, users can upload a file, or copy and paste the permalink of an associated EMW Media post.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMSELInjectLocation = {
  title: 'MSEL Inject Location',
  content: `
        <p>Set the location for your MSEL Inject anywhere on the map by clicking the location icon. Below the name of the location, the latitude and longitude will be listed. View the map as a traditional Map or Satellite. Select OK to save the location of the MSEL Inject or Cancel to return to the previous page.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpObjectivesMethods = {
  title: 'Objectives & Methods',
  content: `
        <p>Assign a training objective to the MSEL inject from the Available Training Objectives table. Then select the Training Method for each of the assigned training objectives.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMSELInjectReview = {
  title: 'MSEL Inject Review',
  content: `
        <p>Review the content of any inject. Update a section by clicking the stepper that you wish to edit. Upon creation, the inject will be assigned a unique identification number.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpViewInject = {
  title: 'View Inject',
  content: `
        <p>View Inject Details, Status, and Activity Log. The Activity Log shows the workspace user and the time that they edited that inject. Click the more options icon to edit the MSEL Inject.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMselCalendar = {
  title: 'MSEL Calendar',
  content: `
        <p>Monitor the status of the MSEL Injects. Status Labels, chosen in the Status Boards section of Settings, simplify the process of tracking MSEL Statuses. Select Create MSEL Inject to add a new MSEL Inject.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpTrainDashboard = {
  title: 'Manage Dashboard',
  content: `
        <p>The Manage dashboard presents the MSEL Inject Status, Calendar showing dates and times of MSEL Injects, and Participant Objectives that were Requested vs Planned, Planned vs Assessed, and completion status. These displays allow users to quickly view and access critical sections for managing an exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpMSELTimeline = {
  title: 'MSEL Timeline',
  content: `
        <p>View the progress of a MSEL Inject within a specific Scenario. Begin by selecting the All Events drop-down. A complete MSEL is green, which means that the MSEL was injected and completed. A yellow status means that the MSEL is incomplete. Update a MSEL inject by first selecting the name of the MSEL. Once the window populates, update the status, edit the inject, or view and edit Training Objectives here.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpAssessOverview = {
  title: 'Overview',
  content: `
        <p>This page displays a list of all Participant Objectives that have been aligned to a MSEL Inject. Once the MSEL Inject is marked "Complete or Incomplete", users will need to create and submit the respective forms - Assessment (by Observer/Evaluators) and/or Feedback (by Participants). Feedbacks are "Self-Assessments". Press the arrow associated with the Participant to view details and the related Assessment and Feedback Lists. Select Create Assessment or Create Feedback (Self-Assessment) for a participant objective. Each participant objective displays the number of required runs, the number of MSEL injects aligned to, and the number of assessment and feedback forms submitted. If submitting both, Assessment and Feedback counts should be the same, and should match the number for the "Inject Count".</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpAssessList = {
  title: 'Assess List',
  content: `
        <p>This page lists assessments of objectives and shows the status of each. Select Create Assessment to begin filling out the form. Users can also edit or delete forms by selecting the three-dot icon next to each entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const HelpFeedback = {
  title: 'Feedback',
  content: `
        <p>This page lists feedbacks (self-assessments) of objectives and shows the status of each. Select Create Feedback to begin filling out the form. Users can also edit or delete forms by selecting the three-dot icon next to each entry.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

// Notebook

export const Notebook = {
  title: 'Notebook',
  content: `
        <p>Create collaborative notebooks to organize your workspace content. Give the notebook a title, color, and icon as unique identifiers. Select Create Notebook to start customizing a unique, collaborative Notebook. Stay organized by creating folders and uploading files to support the exercise.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};

export const FoldersandFileUploads = {
  title: 'Folders and File Uploads',
  content: `
        <p>Select the "Create" button to create a folder. Use the Files tab to upload files in the main section or in a folder. Files include documents, presentations, spreadsheets, images, and videos.</p>
        `,
  link: PRATUS_KNOWLEDGE_URL,
};
